<template>
  <div></div>
</template>

<script>
import { isNavigationFailure, NavigationFailureType } from 'vue-router';

export default {
  name: 'Home',

  mounted() {
    this.$router.push('/routing-status')
      .catch((err) => {
        const isRedirectFailure = isNavigationFailure(
          err,
          NavigationFailureType.redirected
        );

        if (!isRedirectFailure) {
          console.error('Error: ', err);
        }
      });
  }
};
</script>

<style lang="scss" scoped>
</style>
